import { render, staticRenderFns } from "./fsExport.vue?vue&type=template&id=a97a6bc8"
import script from "./fsExport.vue?vue&type=script&lang=js"
export * from "./fsExport.vue?vue&type=script&lang=js"
import style0 from "./fsExport.vue?vue&type=style&index=0&id=a97a6bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports